module.exports = __webpack_public_path__ + "static/media/quantitative_int.b6c0bc72.svg";